import Text from '@/v2/components/Typography/Text';
import Colors from '@/v2/constants/Colors';
import Button from '@/v2/components/Button/Button';
import Alert from '@/v2/components/Alert/Alert';

import {
  Container,
  ScrollableContainer,
  FooterContainer,
  ErrorContainer,
} from './BaseModal.styled';

const defaultButtons = {
  cancel: true,
};

export default function BaseModal({
  title,
  SaveButton,
  buttons,
  scrollable = false,
  children,
  error,
  cancelText,
  ...props
}) {
  const buttonsConfig = { ...defaultButtons, ...buttons, cancelText };

  const handleCancel = (e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    if (props.onCancel) {
      props.onCancel(e);
    }
  };

  if (!props.visible) return null;

  return (
    <Container
      title={
        <Text color={Colors.BLACK} variant="title-small-grey-22">
          {title}
        </Text>
      }
      $scrollable={scrollable}
      onCancel={handleCancel}
      footer={
        <Footer
          buttonsConfig={buttonsConfig}
          SaveButton={SaveButton}
          error={error}
          handleCancel={handleCancel}
        />
      }
      getContainer={() => document.body}
      destroyOnClose={true}
      {...props}
    >
      {scrollable ? (
        <ScrollableContainer>{children}</ScrollableContainer>
      ) : (
        children
      )}
    </Container>
  );
}

function Footer({ buttonsConfig, SaveButton, error, handleCancel }) {
  const footer = (
    <FooterContainer>
      {buttonsConfig.cancel ? (
        <Button key="cancel" onClick={handleCancel}>
          {buttonsConfig.cancelText ?? 'Cancel'}
        </Button>
      ) : null}
      {SaveButton}
    </FooterContainer>
  );

  if (error) {
    return (
      <ErrorContainer>
        <Alert type="error" message={error} />
        {footer}
      </ErrorContainer>
    );
  }

  return footer;
}
